/*eslint-disable */
import axios from 'axios';
var jwt = require('jwt-simple');
import root from '../_helpers/roots';
import jwt_decode from 'jwt-decode'
let checkLoginTypeLink = root.checkLoginType.link;
let loginWithOtpLink = root.loginWithOtp.link
let signupLink = root.signUp.link;
let loginLink = root.signupSubscriberLogin.link;
let refreshTokenLink = root.refreshToken.link;
import Vue from 'vue'
// const authentication = {
export default {
  state: {
    status: '',
    token: localStorage.getItem('t') || '',
    user: {},
    message: '',
    time: '',
    registerConfirmationDetails: {}
    //  setUser: localStorage.getItem('setUser') || ''
  },
  mutations: {
    auth_request(state) {
      state.status = 'loading'
    },
    logout(state) {
      state.status = ''
      state.token = ''
      localStorage.removeItem('t');
      delete axios.defaults.headers.common['Authorization']
      // localStorage.removeItem('rf');
      // localStorage.removeItem('cl');
      // localStorage.clear('v');
    },
    updateToken(state, newToken) {
      localStorage.setItem('t', newToken);
      state.token = newToken;
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('t');
    },
    updateRefershToken(state, newToken) {
      localStorage.setItem('rf', newToken);
    },
    removeToken(state) {
      localStorage.removeItem('t');
      localStorage.removeItem('rf');
      state.token = ''
    },
    setTime(state, newTime) {
      localStorage.setItem('cl', newTime)
    },
    registerConfirmationMut(state, value) {
      state.registerConfirmationDetails = value
    }
  },
  actions: {
    checkLoginType(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post(checkLoginTypeLink, payload)
          .then(
            (response) => {
              resolve(response);
            }
          )
          .catch((error) => {
            // localStorage.removeItem('loginType');
            reject(error);
          })
      })
    },
    loginWithOtp(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post(loginWithOtpLink, payload)
          .then(
            (response) => {
              let accessToken = response.data.data.access;
              let refershToken = response.data.data.refresh;
              let loginTime = new Date().getMinutes();
              let timePayload = {
                time: loginTime
              };
              // Encode Time token Payload: time payload and secreate key refresh token
              let loginTimeEncode = jwt.encode(timePayload, refershToken)
              this.commit('updateToken', accessToken);
              // this.commit('updateRefershToken', refershToken);
              // this.commit('setTime', loginTimeEncode)

              resolve(response);
            }
          )
          .catch((error) => {
            localStorage.removeItem('t');
            localStorage.removeItem('rf');
            reject(error);
          })
      })
    },
    login(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post(loginLink, payload)
          .then(
            (response) => {
              let accessToken = response.data.data.access;
              //   console.log('accesstoken',accessToken);
              let refershToken = response.data.data.refresh;
              let loginTime = new Date().getMinutes();
              let timePayload = {
                time: loginTime
              };
              // Encode Time token Payload: time payload and secreate key refresh token
              let loginTimeEncode = jwt.encode(timePayload, refershToken)
              this.commit('updateToken', accessToken);
              // this.commit('updateRefershToken', refershToken);
              // this.commit('setTime', loginTimeEncode)
              resolve(response);
            }
          )
          .catch((error) => {
            localStorage.removeItem('t');
            localStorage.removeItem('rf');
            reject(error);
          })
      })
    },
    // refreshToken(){
    //     const payload = {
    //         token: localStorage.getItem('rf')
    //     }
    //     axios.post(refreshTokenLink, payload)
    //     .then((response)=>{
    //         this.commit('updateToken', response.data.access);
    //         let loginTime= new Date().getMinutes();
    //         let timePayload = {time: loginTime};

    //         let loginTimeEncode = jwt.encode(timePayload, refershToken)
    //         this.commit('setTime', loginTimeEncode)

    //     })
    //     .catch((error) => {
    //         console.log(error);
    //     })
    // },
    register({
      commit
    }, user) {
      return new Promise((resolve, reject) => {
        commit('auth_request')
        axios({
            url: signupLink,
            data: user,
            method: 'POST'
          })
          .then(resp => {
            commit('registerConfirmationMut', resp.data)
            resolve(resp)
          })
          .catch(err => {
            //commit('auth_error', err);
            localStorage.removeItem('token')
            reject(err)
          })
      })
    },
    logout(context) {
      return new Promise((resolve, reject) => {
        context.commit('logout')
        delete axios.defaults.headers.common['Authorization']
        resolve()
      })
    },
    getAuthHeader() {
      return {
        'Authorization': 'Bearer ' + localStorage.getItem('t')
      }
    },
    checkAuth() {
      let jwt = localStorage.getItem('t');
      if (jwt != null && jwt != '') {
        this.commit('updateToken', jwt);
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + jwt;
      } else {
        localStorage.removeItem('t');
        this.dispatch('logout');
      }

    },
  },
  getters: {
    isAuthenticated: state => !!state.token,
    authStatus: state => state.status,
    registerConfirmationDetailsState: state => state.registerConfirmationDetails
  }
}
//export default authentication;